import { EstateResultItem_OneViewEmploymentInput } from 'queries';

import Asset from './asset';

type Props = {
  id: string;
  showAssetBtn: boolean;
  employment: EstateResultItem_OneViewEmploymentInput;
  assignButton?: React.ReactNode;
  title: string;
  subtitle: string;
};

export default function EmploymentAsset({
  id,
  showAssetBtn,
  assignButton,
  title,
  subtitle,
}: Props) {
  return (
    <Asset
      key={id}
      showAssetBtn={showAssetBtn}
      assignButton={assignButton}
      title={title}
      subtitle={subtitle}
    />
  );
}
